import type { FaireProductEntity } from "../../entity_types/product";

export const p_d2nzb2jq9s: FaireProductEntity = {
  token: "p_d2nzb2jq9s",
  type: "product",
  name: "COCO ROSE I Bath Bomb - Luxurious Bath Experience",
  brandToken: "b_x9g88vqesu",
  brandName: "Phyzzy",
  imageUrl:
    "https://cdn.faire.com/fastly/e02d8a376cc915ab4875206a739275d36d701795067d659cbd20455c849121f4.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5063cf3885878c900d7ed81e264d18ef8a8148f80664b4d00d6b20742d4a4cbc.png",
    "https://cdn.faire.com/fastly/0b4338bc2b26543e6209bf1eadfefb8d54d4c1aa06425ed11672feba94ac593c.png",
    "https://cdn.faire.com/fastly/8e7046ae4f396a5bec4b8c7aa1d588e6ae4d3c8244f4d7caeb7be6bb154e5f2c.png",
    "https://cdn.faire.com/fastly/f6e09986cbcf8427b10904f95dc7708f69dabf3fc51c874d738ed20c77716ba4.png",
    "https://cdn.faire.com/fastly/0292213613b44571a3b62d3df4cf26614083a76f464afe17ee4efac30ce5c4ef.jpeg",
  ],
  priceDollars: 6.89,
  description:
    "Transform your bath time into a luxurious spa experience with this exquisite Coco Rose Bath Bomb. Delicately adorned with dried rose buds and shimmering silver accents, this elegant bath fizzer creates a visually stunning display as it dissolves. The harmonious blend of cocoa butter delivers deep moisturization while the combination of Epsom and Himalayan salts helps soothe tired muscles and create a truly indulgent bathing ritual. Each bath bomb is carefully crafted to provide a perfect balance of nourishing ingredients that leave your skin feeling soft, smooth, and pampered. The beautiful presentation makes it an ideal gift or a wonderful way to treat yourself to a moment of tranquility.\n\nImportant: these are handmade products and color can vary batch to batch.",
  tags: [],
  msrpDollars: 16.64,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:16.781Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
